import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const query = gql`
  query MagicLogin($uuid: ID!, $identifier: String!, $code: String!, $businessId: String) {
    magicLogin(uuid: $uuid, identifier: $identifier, code: $code, businessId: $businessId) {
      logins {
        status
        business {
          uuid
          businessName
          subdomain
        }
        auth {
          accessToken
          legacyToken
        }
        branding {
          businessLogoUrl
        }
      }
    }
  }
`

export const magicLoginKey = getQueryNames(query)[0]

export default query
